/* eslint-disable no-loss-of-precision */
import blank from '../Blank/blankData'

import BeardAbLincoln from '../FacialHair/BeardAbLincoln'
import BeardSquare from '../FacialHair/BeardSquare'
import GoateeVanDyke from '../FacialHair/GoateeVanDyke'
import MustacheOval from '../FacialHair/MustacheOval'
import BeardChinBeard from '../FacialHair/BeardChinBeard'
import BeardStubble from '../FacialHair/BeardStubble'
import Mustache2Pieces from '../FacialHair/Mustache2Pieces'
import SideBurnsSmall from '../FacialHair/SideBurnsSmall'
import BeardLongBeard from '../FacialHair/BeardLongBeard'
import BeardW from '../FacialHair/BeardW'
import MustacheFull from '../FacialHair/MustacheFull'
import SideBurnsWolverine from '../FacialHair/SideBurnsWolverine'
import BeardSbAndStache from '../FacialHair/BeardSbAndStache'
import GoateeFull from '../FacialHair/GoateeFull'
import MustacheHandlebar from '../FacialHair/MustacheHandlebar'
import BeardSoulPatch from '../FacialHair/BeardSoulPatch'
import GoateeTony from '../FacialHair/GoateeTony'
import MustacheLong from '../FacialHair/MustacheLong'

const data = [
  blank,
  {
    id: 'BeardAbLincoln',
    svg: BeardAbLincoln,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 105.28369140625,
        scaleX: 1.05,
      },
      pointWide: {
        y: 100.8443603515625,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 101.52046203613281,
        scaleX: 1.1,
      },
      roundWide: {
        y: 100.67301940917969,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 101.57937622070312,
        scaleX: 1.1,
      },
      squareWide: {
        y: 100.10043334960938,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'BeardSquare',
    svg: BeardSquare,
    positioning: {
      pointNarrow: {
        y: 108,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 108.28369140625,
        scaleX: 1.05,
      },
      pointWide: {
        y: 108.8443603515625,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 108,
        scaleX: 1,
      },
      roundMedium: {
        y: 108.52046203613281,
        scaleX: 1.1,
      },
      roundWide: {
        y: 108.67301940917969,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 108,
        scaleX: 1,
      },
      squareMedium: {
        y: 108.57937622070312,
        scaleX: 1.1,
      },
      squareWide: {
        y: 108.10043334960938,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'GoateeVanDyke',
    svg: GoateeVanDyke,
    positioning: {
      pointNarrow: {
        y: 121.40328979492188,
        scaleX: 1,
      },
      pointMedium: {
        y: 121.18338012695312,
        scaleX: 1,
      },
      pointWide: {
        y: 118.44908142089844,
        scaleX: 1,
      },
      roundNarrow: {
        y: 121.27020263671875,
        scaleX: 1,
      },
      roundMedium: {
        y: 120.47389221191406,
        scaleX: 1,
      },
      roundWide: {
        y: 121.5213623046875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 119.38111877441406,
        scaleX: 1,
      },
      squareMedium: {
        y: 119.3494873046875,
        scaleX: 1,
      },
      squareWide: {
        y: 121.48040771484375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'MustacheOval',
    svg: MustacheOval,
    positioning: {
      pointNarrow: {
        y: 122.19317626953125,
        scaleX: 1,
      },
      pointMedium: {
        y: 123.18675231933594,
        scaleX: 1,
      },
      pointWide: {
        y: 120.52738952636719,
        scaleX: 1,
      },
      roundNarrow: {
        y: 123.09625244140625,
        scaleX: 1,
      },
      roundMedium: {
        y: 123.27536010742188,
        scaleX: 1,
      },
      roundWide: {
        y: 123.04310607910156,
        scaleX: 1,
      },
      squareNarrow: {
        y: 119.45602416992188,
        scaleX: 1,
      },
      squareMedium: {
        y: 121.13836669921875,
        scaleX: 1,
      },
      squareWide: {
        y: 121.85810852050781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BeardChinBeard',
    svg: BeardChinBeard,
    positioning: {
      pointNarrow: {
        y: 131.80938720703125,
        scaleX: 1,
      },
      pointMedium: {
        y: 131.19447326660156,
        scaleX: 1,
      },
      pointWide: {
        y: 130.32977294921875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 130.3464813232422,
        scaleX: 1,
      },
      roundMedium: {
        y: 130.59776306152344,
        scaleX: 1,
      },
      roundWide: {
        y: 132.53395080566406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 129.40573120117188,
        scaleX: 1,
      },
      squareMedium: {
        y: 130.6129913330078,
        scaleX: 1,
      },
      squareWide: {
        y: 131.2677001953125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BeardStubble',
    svg: BeardStubble,
    positioning: {
      pointNarrow: {
        y: 112.2,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 110.19447326660156,
        scaleX: 1.1,
      },
      pointWide: {
        y: 110.32977294921875,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 110.3464813232422,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 110.59776306152344,
        scaleX: 1.1,
      },
      roundWide: {
        y: 110.53395080566406,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 110.40573120117188,
        scaleX: 0.97,
      },
      squareMedium: {
        y: 110.6129913330078,
        scaleX: 1.1,
      },
      squareWide: {
        y: 110.2677001953125,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Mustache2Pieces',
    svg: Mustache2Pieces,
    positioning: {
      pointNarrow: {
        y: 125.03660583496094,
        scaleX: 1,
      },
      pointMedium: {
        y: 124.90560913085938,
        scaleX: 1,
      },
      pointWide: {
        y: 123.3685302734375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 124.24876403808594,
        scaleX: 1,
      },
      roundMedium: {
        y: 124.91194152832031,
        scaleX: 1,
      },
      roundWide: {
        y: 124.87693786621094,
        scaleX: 1,
      },
      squareNarrow: {
        y: 122.56446838378906,
        scaleX: 1,
      },
      squareMedium: {
        y: 122.83091735839844,
        scaleX: 1,
      },
      squareWide: {
        y: 124.06425476074219,
        scaleX: 1,
      },
    },
  },
  {
    id: 'SideBurnsSmall',
    svg: SideBurnsSmall,
    positioning: {
      pointNarrow: {
        y: 111.59048461914062,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 112.02268981933594,
        scaleX: 1.05,
      },
      pointWide: {
        y: 104.90798950195312,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 111.04493713378906,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 109.87345886230469,
        scaleX: 1.1,
      },
      roundWide: {
        y: 109.62171936035156,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 109.29953002929688,
        scaleX: 1,
      },
      squareMedium: {
        y: 109.36360168457031,
        scaleX: 1.1,
      },
      squareWide: {
        y: 112.24063110351562,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'BeardLongBeard',
    svg: BeardLongBeard,
    positioning: {
      pointNarrow: {
        y: 122.59048461914062,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 122.02268981933594,
        scaleX: 1.05,
      },
      pointWide: {
        y: 122.90798950195312,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 122.04493713378906,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 122.87345886230469,
        scaleX: 1.1,
      },
      roundWide: {
        y: 122.62171936035156,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 122.29953002929688,
        scaleX: 1,
      },
      squareMedium: {
        y: 122.36360168457031,
        scaleX: 1.1,
      },
      squareWide: {
        y: 122.24063110351562,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'BeardW',
    svg: BeardW,
    positioning: {
      pointNarrow: {
        y: 111.59048461914062,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 112.02268981933594,
        scaleX: 1.05,
      },
      pointWide: {
        y: 104.90798950195312,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 111.04493713378906,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 109.87345886230469,
        scaleX: 1.1,
      },
      roundWide: {
        y: 109.62171936035156,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 109.29953002929688,
        scaleX: 1,
      },
      squareMedium: {
        y: 109.36360168457031,
        scaleX: 1.1,
      },
      squareWide: {
        y: 112.24063110351562,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'MustacheFull',
    svg: MustacheFull,
    positioning: {
      pointNarrow: {
        y: 120.72175598144531,
        scaleX: 1,
      },
      pointMedium: {
        y: 121.94871520996094,
        scaleX: 1,
      },
      pointWide: {
        y: 119.70381164550781,
        scaleX: 1,
      },
      roundNarrow: {
        y: 120.77296447753906,
        scaleX: 1,
      },
      roundMedium: {
        y: 121.20651245117188,
        scaleX: 1,
      },
      roundWide: {
        y: 121.78273010253906,
        scaleX: 1,
      },
      squareNarrow: {
        y: 119.22860717773438,
        scaleX: 1,
      },
      squareMedium: {
        y: 119.52848815917969,
        scaleX: 1,
      },
      squareWide: {
        y: 120.29542541503906,
        scaleX: 1,
      },
    },
  },
  {
    id: 'SideBurnsWolverine',
    svg: SideBurnsWolverine,
    positioning: {
      pointNarrow: {
        y: 107.98507690429688,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 107.39694213867188,
        scaleX: 1.05,
      },
      pointWide: {
        y: 105.35795593261719,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 110.58071899414062,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 108.01873779296875,
        scaleX: 1.1,
      },
      roundWide: {
        y: 108.19581604003906,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 108.96238708496094,
        scaleX: 1,
      },
      squareMedium: {
        y: 108.39801025390625,
        scaleX: 1.1,
      },
      squareWide: {
        y: 108.53485107421875,
        scaleX: 1.35,
      },
    },
  },
  {
    id: 'BeardSbAndStache',
    svg: BeardSbAndStache,
    positioning: {
      pointNarrow: {
        y: 93.0322265625,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 94.43019104003906,
        scaleX: 1.1,
      },
      pointWide: {
        y: 92.21258544921875,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 95.90574645996094,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 95.57923889160156,
        scaleX: 1.1,
      },
      roundWide: {
        y: 95.24284362792969,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 93.24331665039062,
        scaleX: 1,
      },
      squareMedium: {
        y: 91.41963195800781,
        scaleX: 1.1,
      },
      squareWide: {
        y: 93.84648132324219,
        scaleX: 1.35,
      },
    },
  },
  {
    id: 'GoateeFull',
    svg: GoateeFull,
    positioning: {
      pointNarrow: {
        y: 120.53681945800781,
        scaleX: 1,
      },
      pointMedium: {
        y: 120.67329406738281,
        scaleX: 1,
      },
      pointWide: {
        y: 118.76123046875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 121.10263061523438,
        scaleX: 1,
      },
      roundMedium: {
        y: 120.47731018066406,
        scaleX: 1,
      },
      roundWide: {
        y: 120.34689331054688,
        scaleX: 1,
      },
      squareNarrow: {
        y: 118.04515075683594,
        scaleX: 1,
      },
      squareMedium: {
        y: 117.35711669921875,
        scaleX: 1,
      },
      squareWide: {
        y: 118.95198059082031,
        scaleX: 1,
      },
    },
  },
  {
    id: 'MustacheHandlebar',
    svg: MustacheHandlebar,
    positioning: {
      pointNarrow: {
        y: 119.65310668945312,
        scaleX: 1,
      },
      pointMedium: {
        y: 120.63700866699219,
        scaleX: 1,
      },
      pointWide: {
        y: 118.32598876953125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 120.33283996582031,
        scaleX: 1,
      },
      roundMedium: {
        y: 121.61189270019531,
        scaleX: 1,
      },
      roundWide: {
        y: 121.14399719238281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 117.43807983398438,
        scaleX: 1,
      },
      squareMedium: {
        y: 118.97264099121094,
        scaleX: 1,
      },
      squareWide: {
        y: 119.08128356933594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BeardSoulPatch',
    svg: BeardSoulPatch,
    positioning: {
      pointNarrow: {
        y: 141.0733184814453,
        scaleX: 1,
      },
      pointMedium: {
        y: 140.39846801757812,
        scaleX: 1,
      },
      pointWide: {
        y: 139.21597290039062,
        scaleX: 1,
      },
      roundNarrow: {
        y: 139.965087890625,
        scaleX: 1,
      },
      roundMedium: {
        y: 140.9879913330078,
        scaleX: 1,
      },
      roundWide: {
        y: 138.89988708496094,
        scaleX: 1,
      },
      squareNarrow: {
        y: 137.45932006835938,
        scaleX: 1,
      },
      squareMedium: {
        y: 139.1742706298828,
        scaleX: 1,
      },
      squareWide: {
        y: 138.42466735839844,
        scaleX: 1,
      },
    },
  },
  {
    id: 'GoateeTony',
    svg: GoateeTony,
    positioning: {
      pointNarrow: {
        y: 124.53822326660156,
        scaleX: 1,
      },
      pointMedium: {
        y: 122.57185363769531,
        scaleX: 1,
      },
      pointWide: {
        y: 120.48683166503906,
        scaleX: 1,
      },
      roundNarrow: {
        y: 123.27241516113281,
        scaleX: 1,
      },
      roundMedium: {
        y: 121.97531127929688,
        scaleX: 1,
      },
      roundWide: {
        y: 122.82429504394531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 121.15400695800781,
        scaleX: 1,
      },
      squareMedium: {
        y: 121.52902221679688,
        scaleX: 1,
      },
      squareWide: {
        y: 121.47230529785156,
        scaleX: 1,
      },
    },
  },
  {
    id: 'MustacheLong',
    svg: MustacheLong,
    positioning: {
      pointNarrow: {
        y: 120.35966491699219,
        scaleX: 1,
      },
      pointMedium: {
        y: 121.13374328613281,
        scaleX: 1,
      },
      pointWide: {
        y: 118.99678039550781,
        scaleX: 1,
      },
      roundNarrow: {
        y: 122.5699462890625,
        scaleX: 1,
      },
      roundMedium: {
        y: 122.10954284667969,
        scaleX: 1,
      },
      roundWide: {
        y: 120.53240966796875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 118.03651428222656,
        scaleX: 1,
      },
      squareMedium: {
        y: 120.44166564941406,
        scaleX: 1,
      },
      squareWide: {
        y: 119,
        scaleX: 1,
      },
    },
  },
]
export default data
